export type PhaseKey =
  | 'preDesign'
  | 'schematicDesign'
  | 'designDevelopment'
  | 'constructionDocuments'
  | 'bidNegotiation'
  | 'permitting'
  | 'constructionAdministration'
  | 'permitFilingFee';

export const PHASE_KEYS: PhaseKey[] = [
  'preDesign',
  'schematicDesign',
  'designDevelopment',
  'constructionDocuments',
  'bidNegotiation',
  'permitting',
  'constructionAdministration',
  'permitFilingFee',
];

export const YES_NO_OPTIONS = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

export const CLIENT_TYPE_OPTIONS = [
  { label: 'Ambulatory Care Center', value: 'ambulatoryCareCenter' },
  { label: 'Architect', value: 'architect' },
  { label: 'Church', value: 'church' },
  { label: 'Commercial', value: 'commercial' },
  { label: 'Design-Build Contractor', value: 'designBuildContractor' },
  { label: 'Engineer', value: 'engineer' },
  { label: 'Government', value: 'government' },
  { label: 'Health System', value: 'healthSystem' },
  { label: 'Hospital', value: 'hospital' },
  { label: 'Law Firm', value: 'lawFirm' },
  { label: 'Municipality', value: 'municipality' },
  { label: 'Physician Practice', value: 'physicianPractice' },
  { label: 'Private', value: 'private' },
  { label: 'Property Management Company', value: 'propertyManagementCompany' },
  { label: 'Real Estate Holding Company', value: 'realEstateHoldingCompany' },
  { label: 'Residential', value: 'residential' },
  { label: 'Retail', value: 'retail' },
  { label: 'School', value: 'school' },
  { label: 'Senior Living Facility', value: 'seniorLivingFacility' },
  { label: 'Structural Engineers', value: 'structuralEngineers' },
  { label: 'Other', value: 'other' },
];

export const PROJECT_TYPE_OPTIONS = [
  { label: 'Healthcare', value: 'healthcare' },
  { label: 'Higher Education', value: 'higherEducation' },
  { label: 'K-12 Education', value: 'k12Education' },
  { label: 'Civic & Public Safety', value: 'civicAndPublicSafety' },
  { label: 'Senior Living', value: 'seniorLiving' },
  { label: 'Hospitality & Themed Entertainment', value: 'hospitalityAndThemedEntertainment' },
  { label: 'Industrial', value: 'industrial' },
  { label: 'Workplace/Corporate', value: 'workplaceCorporate' },
  { label: 'Religious/Faith-Based', value: 'religiousFaithBased' },
  { label: 'Other', value: 'other' },
];

export const PROJECT_TYPE_OPTIONS_OLD = [
  { label: 'Building Additions', value: 'buildingAdditions' },
  {
    label: 'Concept Design without Construction Documents',
    value: 'conceptDesignWithoutConstructionDocuments',
  },
  { label: 'Feasibility Study', value: 'feasibilityStudy' },
  { label: 'Master Planning', value: 'masterPlanning' },
  { label: 'New Building', value: 'newBuilding' },
  { label: 'Renovations', value: 'renovations' },
  {
    label: 'Schematic Design without Construction Documents',
    value: 'schematicDesignWithoutConstructionDocuments',
  },
  { label: 'Other', value: 'other' },
];

export const FACILITY_OPTIONS_HEALTHCARE = [
  { label: 'Acute Care Hospital', value: 'acuteCareHospital' },
  { label: 'Bed Tower / Patient Tower', value: 'bedTowerPatientTower' },
  { label: 'Medical Office Building (MOB)', value: 'medicalOfficeBuildingMob' },
  { label: 'Outpatient / Ambulatory Surgery Center', value: 'outpatientAmbulatorySurgeryCenter' },
  { label: 'Emergency Department', value: 'emergencyDepartment' },
  { label: 'Imaging Suite', value: 'imagingSuite' },
  { label: 'Behavioral Health Facility', value: 'behavioralHealthFacility' },
  { label: 'Cancer Center', value: 'cancerCenter' },
  { label: 'Central Utility Plant (CUP)', value: 'centralUtilityPlantCup' },
  {
    label: 'Support Services (Sterile Processing, Pharmacy, Lab)',
    value: 'supportServicesSterileProcessingPharmacyLab',
  },
];

export const FACILITY_OPTIONS_HIGHER_EDUCATION = [
  { label: 'Academic Building', value: 'academicBuilding' },
  { label: 'Laboratory / Research Building', value: 'laboratoryResearchBuilding' },
  { label: 'Student Housing', value: 'studentHousing' },
  { label: 'Dining', value: 'dining' },
  { label: 'Recreation / Wellness', value: 'recreationWellness' },
  { label: 'Performing Arts', value: 'performingArts' },
  { label: 'Athletics Facility', value: 'athleticsFacility' },
  { label: 'Renovation / Adaptive Reuse', value: 'renovationAdaptiveReuse' },
];

export const FACILITY_OPTIONS_K12_EDUCATION = [
  { label: 'Elementary School', value: 'elementarySchool' },
  { label: 'Middle School', value: 'middleSchool' },
  { label: 'High School', value: 'highSchool' },
  { label: 'CTE / Specialty Program Facility', value: 'cteSpecialtyProgramFacility' },
  { label: 'Athletics Facility', value: 'athleticsFacility' },
  { label: 'Additions / Renovations', value: 'additionsRenovations' },
];

export const FACILITY_OPTIONS_CIVIC_PUBLIC_SAFETY = [
  { label: 'Courthouse', value: 'courthouse' },
  { label: 'Public Safety / Fire Station', value: 'publicSafetyFireStation' },
  { label: 'Justice Facility', value: 'justiceFacility' },
  { label: 'Community Center', value: 'communityCenter' },
  { label: 'Municipal Administration', value: 'municipalAdministration' },
  { label: 'Library', value: 'library' },
  { label: 'Convention Center', value: 'conventionCenter' },
];

export const FACILITY_OPTIONS_SENIOR_LIVING = [
  { label: 'Independent Living', value: 'independentLiving' },
  { label: 'Assisted Living', value: 'assistedLiving' },
  { label: 'Skilled Nursing', value: 'skilledNursing' },
  { label: 'Memory Care', value: 'memoryCare' },
  {
    label: 'Continuing Care Retirement Community (CCRC)',
    value: 'continuingCareRetirementCommunityCcrc',
  },
  { label: 'Senior Housing', value: 'seniorHousing' },
  { label: 'Veteran’s Affairs', value: 'veteransAffairs' },
];

export const FACILITY_OPTIONS_HOSPITALITY_THEMED_ENTERTAINMENT = [
  { label: 'Hotel', value: 'hotel' },
  { label: 'Resort', value: 'resort' },
  { label: 'Conference/Event Facility', value: 'conferenceEventFacility' },
  { label: 'Entertainment Venue', value: 'entertainmentVenue' },
  { label: 'Theme Park', value: 'themePark' },
];

export const FACILITY_OPTIONS_INDUSTRIAL = [
  { label: 'Manufacturing', value: 'manufacturing' },
  { label: 'Distribution Center', value: 'distributionCenter' },
  { label: 'Mission-Critical/Data Center', value: 'missionCriticalDataCenter' },
  { label: 'Technology/R&D', value: 'technologyRandD' },
];

export const FACILITY_OPTIONS_GENERAL = [
  { label: 'Interior Renovations', value: 'interiorRenovations' },
  { label: 'Additions', value: 'additions' },
  { label: 'Ground-Up Construction', value: 'groundUpConstruction' },
  { label: 'Master Planning', value: 'masterPlanning' },
];

export const ALL_FACILITY_OPTIONS = [
  ...FACILITY_OPTIONS_HEALTHCARE,
  ...FACILITY_OPTIONS_HIGHER_EDUCATION,
  ...FACILITY_OPTIONS_K12_EDUCATION,
  ...FACILITY_OPTIONS_CIVIC_PUBLIC_SAFETY,
  ...FACILITY_OPTIONS_SENIOR_LIVING,
  ...FACILITY_OPTIONS_HOSPITALITY_THEMED_ENTERTAINMENT,
  ...FACILITY_OPTIONS_INDUSTRIAL,
  ...FACILITY_OPTIONS_GENERAL,
];

export const getProjectFacilityOptions = (projectType?: string) => {
  let options: { label: string; value: string }[];
  switch (projectType) {
    case 'healthcare':
      options = [...FACILITY_OPTIONS_HEALTHCARE];
      break;
    case 'higherEducation':
      options = [...FACILITY_OPTIONS_HIGHER_EDUCATION];
      break;
    case 'k12Education':
      options = [...FACILITY_OPTIONS_K12_EDUCATION];
      break;
    case 'civicAndPublicSafety':
      options = [...FACILITY_OPTIONS_CIVIC_PUBLIC_SAFETY];
      break;
    case 'seniorLiving':
      options = [...FACILITY_OPTIONS_SENIOR_LIVING];
      break;
    case 'hospitalityAndThemedEntertainment':
      options = [...FACILITY_OPTIONS_HOSPITALITY_THEMED_ENTERTAINMENT];
      break;
    case 'industrial':
      options = [...FACILITY_OPTIONS_INDUSTRIAL];
      break;
    case 'workplaceCorporate':
      options = [];
      break;
    default:
      options = [];
      break;
  }

  options.push(...FACILITY_OPTIONS_GENERAL);

  return options;
};

export const PROJECT_FACILITY_OPTIONS = [
  { label: 'Acute', value: 'acute' },
  { label: 'Ambulatory', value: 'ambulatory' },
  { label: 'Church', value: 'church' },
  { label: 'Commercial', value: 'commercial' },
  { label: 'Educational Facilities', value: 'educationalFacilities' },
  { label: 'Energy Plant', value: 'energyPlant' },
  { label: 'Government', value: 'government' },
  { label: 'Residential Care', value: 'residentialCare' },
  { label: 'Other', value: 'other' },
];

export const PROJECT_SERVICE_OPTIONS = [
  { label: 'Architecture', value: 'architecture' },
  { label: 'Interior Design', value: 'interiorDesign' },
  { label: 'Planning', value: 'planning' },
  { label: 'Programming', value: 'programming' },
  { label: 'Master Planning', value: 'masterPlanning' },
  { label: 'Engineering – MEP', value: 'engineeringMep' },
  { label: 'BIM / VDC', value: 'bimVdc' },
  { label: 'Visualization', value: 'visualization' },
  { label: 'FF&E', value: 'ffe' },
  { label: 'Entitlements / Permitting Support', value: 'entitlementsPermittingSupport' },
  { label: 'Cost Estimating (if provided in-house)', value: 'costEstimatingIfProvidedInHouse' },
  { label: 'Specialty Consulting', value: 'specialtyConsulting' },
];

export const DELIVERY_METHOD_OPTIONS = [
  { label: 'CM-at-Risk (CMAR)', value: 'cmAtRisk', abbreviation: 'CMAR' },
  { label: 'Design–Bid–Build (DBB)', value: 'designBidBuild', abbreviation: 'DBB' },
  { label: 'Design–Build (DB)', value: 'designBuild', abbreviation: 'DB' },
  {
    label: 'Integrated Project Delivery (IPD)',
    value: 'integratedProjectDelivery',
    abbreviation: 'IPD',
  },
  {
    label: 'Construction Manager / Advisor (CM/Agent)',
    value: 'constructionManager',
    abbreviation: 'CM/Agent',
  },
  { label: 'Progressive Design–Build', value: 'progressiveDesignBuild', abbreviation: 'PDB' },
  { label: 'Self-Perform (Contractor-Led)', value: 'selfPerform', abbreviation: 'Contractor-Led' },
  { label: 'Other', value: 'other' },
];

export const PROPOSAL_TYPE_OPTIONS = [
  { label: 'RFP', value: 'rfp' },
  { label: 'RFQ', value: 'rfq' },
  { label: 'Direct Award / Sole Source', value: 'directAward' },
  { label: 'Repeat Client Without Bid', value: 'repeatClientWithoutBid' },
  { label: 'Competitive Shortlist', value: 'competitiveShortlist' },
  { label: 'Other', value: 'other' },
];

export const CONTRACT_TYPE_OPTIONS = [
  { label: 'A&E', value: 'aAndE' },
  { label: 'Design Build', value: 'designBuild' },
  { label: 'IPD', value: 'ipd' },
  { label: 'Other', value: 'other' },
];

export const FEE_STRUCTURE_OPTIONS = [
  { label: 'Lump Sum', value: 'lumpSum' },
  { label: 'Hourly Not-to-Exceed', value: 'hourlyNotToExceed' },
  { label: 'Hourly (Open-Ended)', value: 'hourlyOpenEnded' },
  { label: 'Percentage of Construction Cost', value: 'percentageOfConstructionCost' },
  { label: 'Unit Rates', value: 'unitRates' },
  { label: 'Hybrid (Combination of Above)', value: 'hybrid' },
  { label: 'Other', value: 'other' },
];

export const CERTIFICATION_OPTIONS = [
  { label: 'LEED Certified', value: 'leedCertified' },
  { label: 'LEED Silver', value: 'leedSilver' },
  { label: 'LEED Gold', value: 'leedGold' },
  { label: 'LEED Platinum', value: 'leedPlatinum' },
  { label: 'WELL', value: 'well' },
  { label: 'Green Globes', value: 'greenGlobes' },
  { label: 'Living Building Challenge', value: 'livingBuildingChallenge' },
  { label: 'Energy Star', value: 'energyStar' },
  { label: 'None', value: 'none' },
  { label: 'Other', value: 'other' },
];

export const CONSTRUCTION_TYPE_OPTIONS = [
  { label: 'Ground-Up', value: 'groundUp' },
  { label: 'Addition', value: 'addition' },
  { label: 'Renovation', value: 'renovation' },
  { label: 'Adaptive Reuse', value: 'adaptiveReuse' },
  { label: 'Interior Fit-Out', value: 'interiorFitOut' },
];

export const WINNING_CHANCE_OPTIONS = [
  { label: '10%', value: 10 },
  { label: '25%', value: 25 },
  { label: '50%', value: 50 },
  { label: '75%', value: 75 },
  { label: '95%', value: 95 },
];

export const GRACE_ROLES = [
  { label: 'Principal-in-Charge', value: 'principalInCharge' },
  { label: 'Principal', value: 'principal' },
  { label: 'Project Manager', value: 'projectManager' },
  { label: 'Design Lead', value: 'designLead' },
  { label: 'Project Architect', value: 'projectArchitect' },
  { label: 'Technical Lead', value: 'technicalLead' },
  { label: 'Storyteller', value: 'storyteller' },
  { label: 'Interior Designer', value: 'interiorDesigner' },
  { label: 'Planner', value: 'planner' },
  { label: 'BIM Manager/ BIM Coordinator', value: 'bimManagerCoordinator' },
  { label: 'Engineer – MEP', value: 'engineerMep' },
  { label: 'QA/QC Reviewer', value: 'qaQcReviewer' },
  { label: 'Sustainability Lead', value: 'sustainabilityLead' },
  { label: 'Specification Writer', value: 'specificationWriter' },
  { label: 'Visualization Lead', value: 'visualizationLead' },
] as const;

export const CONTRACTOR_ROLES = [
  { label: 'General Contractor', value: 'generalContractor' },
  { label: 'Construction Manager', value: 'constructionManager' },
  { label: 'Developer-Led', value: 'developerLed' },
  { label: 'Owner-Furnished', value: 'ownerFurnished' },
  { label: 'Preconstruction Only', value: 'preconstructionOnly' },
] as const;

export const CONSULTANT_ROLES = [
  { label: 'Civil Engineer', value: 'civilEngineer' },
  { label: 'Structural Engineer', value: 'structuralEngineer' },
  { label: 'MEP Engineer', value: 'mepEngineer' },
  { label: 'Landscape Architect', value: 'landscapeArchitect' },
  { label: 'Surveyor', value: 'surveyor' },
  { label: 'Geotechnical Engineer', value: 'geotechnicalEngineer' },
  { label: 'Acoustic Consultant', value: 'acousticConsultant' },
  { label: 'Low Voltage / Technology', value: 'lowVoltageTechnology' },
  { label: 'AV Consultant', value: 'avConsultant' },
  { label: 'Lighting Designer', value: 'lightingDesigner' },
  { label: 'Cost Estimator', value: 'costEstimator' },
  { label: 'Environmental Consultant', value: 'environmentalConsultant' },
  { label: 'Commissioning Agent', value: 'commissioningAgent' },
] as const;

export const ALL_ROLES = [...GRACE_ROLES, ...CONTRACTOR_ROLES, ...CONSULTANT_ROLES] as const;

export const CHECKLIST_STATUS_OPTIONS = [
  { label: 'New', value: 'new' },
  { label: 'In Progress', value: 'in_progress' },
  { label: 'Completed', value: 'completed' },
];

export const TEST_IMAGE_1 =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEACAIAAADTED8xAAADMElEQVR4nOzVwQnAIBQFQYXff81RUkQCOyDj1YOPnbXWPmeTRef+/3O/OyBjzh3CD95BfqICMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMO0TAAD//2Anhf4QtqobAAAAAElFTkSuQmCC';
export const TEST_IMAGE_2 = TEST_IMAGE_1;
export const TEST_IMAGE_3 = TEST_IMAGE_1;
